<template>
  <div>
    <b-row class="justify-content-md-center m-0 mb-4">
      <b-col lg="6">
        <div v-if="loading" class="mt-5 d-flex justify-content-center">
          <b-spinner label="Loading..." variant="dark" />
        </div>
        <div v-else>
          <create-or-edit-evaluation-assessment :post-id="postId" :part="part" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';

import CreateOrEditEvaluationAssessment from './components/CreateOrEditEvaluationAssessment.vue';
export default {
  components: {
    CreateOrEditEvaluationAssessment
  },
  data() {
    return {
      loading: false
    };
  },

  computed: {
    learningUnitId() {
      return this.$route.params.learningUnitId || null;
    },
    part() {
      return this.$route.params.part ? this.$route.params.part.toUpperCase() : null;
    },
    postId() {
      return this.$route.params.postId || null;
    }
  },

  watch: {
    learningUnitId: {
      immediate: true,
      handler: 'fetch'
    }
  },

  methods: {
    async fetch() {
      const { learningUnitId = null } = this;

      if (!learningUnitId) return;

      this.loading = true;

      try {
        await LearningUnit.api().fetchByLearningUnitId(learningUnitId);
      } catch (error) {
        this.$toast.error(`Cannot fetch Learning Unit, please try again.`);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    }
  }
};
</script>
